function pcReveal(root) {
  var scope = root || document;
  scope.querySelectorAll('[data-pc-reveal]:not(.is-visible)').forEach(function (el) {
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
  });
}

function pcMoney(cents) {
  var dollars = cents / 100;
  var hasCents = Math.round(cents) % 100 !== 0;
  return '$' + dollars.toFixed(hasCents ? 2 : 0);
}

// Per-unit price. Under 10c we show 3 decimals ($0.045) so bulk savings stay visible
// instead of 1,000 and 2,000 both rounding to $0.05.
function pcUnit(cents) {
  if (cents < 10) return '$' + (cents / 100).toFixed(3);
  return '$' + (cents / 100).toFixed(2);
}

// ECF: Contact Form Builder endpoint. Artwork files are sent here (the same
// way ECF's own storefront script submits its forms) because Shopify's cart
// cannot store uploaded files as line item properties.
var PC_ECF_ENDPOINT = 'https://ecf.cirkleinc.com/api/form-submit';
var PC_MAX_FILE_BYTES = 20 * 1024 * 1024;

function pcInit(section) {
  if (!section || section.hasAttribute('data-pc-ready')) return;

  var variantsEl = section.querySelector('[data-pc-variants]');
  var optionsEl = section.querySelector('[data-pc-options]');
  if (!variantsEl || !optionsEl) return;

  section.setAttribute('data-pc-ready', 'true');

  var variants, options;
  try {
    variants = JSON.parse(variantsEl.textContent);
    options = JSON.parse(optionsEl.textContent);
  } catch (e) { return; }

  var defaultEl = section.querySelector('[data-pc-default]');
  var defaultValues = null;
  if (defaultEl) {
    try { defaultValues = JSON.parse(defaultEl.textContent); } catch (e) { defaultValues = null; }
  }

  var selected = {};
  options.forEach(function (opt, i) {
    selected[opt.name] = (defaultValues && defaultValues[i] != null) ? defaultValues[i] : opt.values[0];
  });

  function firstPart(val) { return (val || '').split('|')[0]; }

  function findVariant(overrides) {
    var test = overrides ? Object.assign({}, selected, overrides) : selected;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < options.length; j++) {
        var key = 'option' + (j + 1);
        if (v[key] !== test[options[j].name]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function render() {
    // sync active state on every option tile
    var qtyOtherOn = section.querySelector('[data-pc-qty-other]:checked');
    section.querySelectorAll('[data-pc-opt-btn]').forEach(function (btn) {
      var name = btn.getAttribute('data-opt-name');
      var val = btn.getAttribute('data-opt-value');
      var input = btn.previousElementSibling;
      if (input && input.type === 'radio') {
        // Leave the quantity tiles alone while 'Other' is picked, or re-rendering would untick it.
        if (qtyOtherOn && input.name === qtyOtherOn.name) return;
        input.checked = (selected[name] === val);
      }
    });

    // live-update quantity tile pricing against whatever else is currently selected
    section.querySelectorAll('[data-pc-qty-btn]').forEach(function (btn) {
      var name = btn.getAttribute('data-opt-name');
      var val = btn.getAttribute('data-opt-value');
      var overrides = {}; overrides[name] = val;
      var v = findVariant(overrides);
      var totalEl = btn.querySelector('[data-pc-qty-total]');
      var perEl = btn.querySelector('[data-pc-qty-per]');
      if (v) {
        var qtyNum = parseInt(firstPart(val), 10);
        if (totalEl) totalEl.textContent = pcMoney(v.price);
        if (perEl && qtyNum > 0) perEl.textContent = pcUnit(v.price / qtyNum) + ' each';
        btn.classList.remove('is-disabled');
      } else {
        if (totalEl) totalEl.textContent = 'N/A';
        if (perEl) perEl.textContent = 'Unavailable';
        btn.classList.add('is-disabled');
      }
    });

    // sidebar summary rows
    options.forEach(function (opt) {
      var row = section.querySelector('[data-pc-summary-opt="' + opt.name.replace(/"/g, '\\"') + '"]');
      if (row) row.textContent = firstPart(selected[opt.name]);
    });
    var qtyRow = section.querySelector('[data-pc-summary-qty]');
    var qtyOptName = null;
    options.forEach(function (opt) { if (section.querySelector('[data-pc-qty-grid][data-opt-name="' + opt.name.replace(/"/g, '\\"') + '"]')) qtyOptName = opt.name; });
    if (qtyRow && qtyOptName) qtyRow.textContent = firstPart(selected[qtyOptName]);

    var variant = findVariant();
    var priceEl = section.querySelector('[data-pc-selected-price]');
    var perEl2 = section.querySelector('[data-pc-selected-per]');
    var addBtn = section.querySelector('[data-pc-add-to-cart]');
    var labelEl = section.querySelector('[data-pc-add-label]');

    if (variant) {
      if (priceEl) priceEl.textContent = pcMoney(variant.price);
      if (perEl2 && qtyOptName) {
        var qn = parseInt(firstPart(selected[qtyOptName]), 10);
        perEl2.textContent = qn > 0 ? (pcUnit(variant.price / qn) + ' per unit') : '';
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.setAttribute('data-variant-id', variant.id);
        if (labelEl) labelEl.textContent = variant.available ? (addBtn.getAttribute('data-label-default') || 'Add to Cart') : 'Sold Out';
      }
    } else {
      if (priceEl) priceEl.textContent = 'N/A';
      var isQuoteSelection = !!(section.querySelector('[data-pc-opt-other]:checked') || section.querySelector('[data-pc-qty-other]:checked') || section.querySelector('[data-pc-colour-radio="multi"]:checked'));
            if (perEl2) perEl2.textContent = isQuoteSelection ? 'Request a custom quote below' : "This combination isn't available";
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.removeAttribute('data-variant-id');
        if (labelEl) labelEl.textContent = 'Not available';
      }
    }
    quoteSync(qtyOptName);
  }

  // Radios (including the quantity 'Other' tile and colour choices) fire change after the
  // label click, so re-render then to keep the summary and quote form in step.
  section.addEventListener('change', function () { render(); });

  section.addEventListener('click', function (e) {
    var label = e.target.closest('[data-pc-opt-btn]');
    if (!label || !section.contains(label)) return;
    selected[label.getAttribute('data-opt-name')] = label.getAttribute('data-opt-value');
    render();
  });

  // ---- Quote mode: when 'Other' (size or quantity) or multi-colour is picked ----
  // Shows 'Custom quote' instead of a price, and pre-fills the enquiry form with the
  // product and options so Nick knows what the enquiry is about.
  var autoDetails = '';
  function productTitle() {
    var t = section.querySelector('.pc-summary-row .pc-val');
    return (t && t.textContent.trim()) || (document.title.split(/\s[|–-]\s/)[0] || '').trim();
  }
  function quoteSync(qtyOptName) {
    var qtyOther = section.querySelector('[data-pc-qty-other]:checked');
    var multiColour = section.querySelector('[data-pc-colour-radio="multi"]:checked');
    var anyOther = false;
    options.forEach(function (opt) { if (opt.name !== qtyOptName && selected[opt.name] === 'Other') anyOther = true; });
    var isQuote = !!(qtyOther || multiColour || anyOther || section.querySelector('[data-pc-opt-other]:checked'));

    var qtyRow = section.querySelector('[data-pc-summary-qty]');
    if (qtyRow && qtyOther) qtyRow.textContent = 'Other';
    if (!isQuote) return;

    var priceEl = section.querySelector('[data-pc-selected-price]');
    var perEl = section.querySelector('[data-pc-selected-per]');
    if (priceEl) priceEl.textContent = 'Custom quote';
    if (perEl) perEl.textContent = "Send us the details below and we'll quote within one business day";

    var details = section.querySelector('[data-pc-quote-form] textarea[name="details"]');
    if (!details) return;
    var lines = ['Product: ' + productTitle()];
    options.forEach(function (opt) {
      if (opt.name === qtyOptName) return;
      var val = firstPart(selected[opt.name]);
      lines.push(opt.name + ': ' + (val === 'Other' ? 'Other (please describe)' : val));
    });
    section.querySelectorAll('[data-pc-choice]:checked').forEach(function (r) { lines.push(r.name.slice(11, -1) + ': ' + r.value); });
    if (multiColour) lines.push('Colours: more than one colour');
    if (qtyOptName) lines.push('Quantity: ' + (qtyOther ? 'Other (how many?)' : firstPart(selected[qtyOptName])));
    var text = lines.join('\n') + '\n\nAnything else we should know (deadline, shape, artwork):\n';
    if (!details.value.trim() || details.value === autoDetails) {
      details.value = text;
      autoDetails = text;
    }
  }

  // ---- Artwork upload UI ----
  var uz = section.querySelector('[data-pc-upload-zone]');
  var fileInput = section.querySelector('[data-pc-file-input]');
  var artExtra = section.querySelector('[data-pc-artwork-extra]');
  var artEmail = section.querySelector('[data-pc-artwork-email]');
  var artError = section.querySelector('[data-pc-artwork-error]');
  var uploadTextEl = uz ? uz.querySelector('[data-pc-upload-text]') : null;
  var uploadTextDefault = uploadTextEl ? uploadTextEl.textContent : '';

  function showArtError(msg) {
    if (!artError) return;
    artError.textContent = msg || '';
    artError.hidden = !msg;
  }

  function currentFile() {
    return (fileInput && fileInput.files && fileInput.files.length) ? fileInput.files[0] : null;
  }

  function syncFileUi() {
    var f = currentFile();
    if (uploadTextEl) uploadTextEl.textContent = f ? ('✓ ' + f.name) : uploadTextDefault;
    if (artExtra) artExtra.hidden = !f;
    showArtError('');
    if (f && f.size > PC_MAX_FILE_BYTES) {
      showArtError('That file is over 20MB. Please choose a smaller file, or add the order now and email your artwork through afterwards.');
    }
  }

  if (fileInput) fileInput.addEventListener('change', syncFileUi);
  if (uz) {
    uz.addEventListener('dragover', function (e) { e.preventDefault(); uz.classList.add('is-dragover'); });
    uz.addEventListener('dragleave', function () { uz.classList.remove('is-dragover'); });
    uz.addEventListener('drop', function (e) {
      e.preventDefault();
      uz.classList.remove('is-dragover');
      if (e.dataTransfer.files.length && fileInput) {
        fileInput.files = e.dataTransfer.files;
        syncFileUi();
      }
    });
  }
  var clearBtn = section.querySelector('[data-pc-file-clear]');
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      if (fileInput) fileInput.value = '';
      syncFileUi();
    });
  }

  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  // Short order reference, e.g. MP-7K3Q9D. Saved on the cart line (shows on the order and the
  // customer's confirmation email) and in the ECF submission, so Nick can match artwork to orders.
  function makeOrderRef() {
    var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    var out = '';
    var rnd = (window.crypto && window.crypto.getRandomValues) ? window.crypto.getRandomValues(new Uint32Array(6)) : null;
    for (var i = 0; i < 6; i++) {
      var n = rnd ? rnd[i] : Math.floor(Math.random() * 4294967296);
      out += chars.charAt(n % chars.length);
    }
    return 'MP-' + out;
  }

  // Sends the artwork to ECF. Resolves when ECF has accepted it.
  function uploadArtwork(file, email, formId, orderRef) {
    var fd = new FormData();
    fd.append('form_id', formId);
    fd.append('email', email);
    fd.append('artwork_specs', 'Order reference: ' + orderRef + ' (product: ' + (document.title.split(/\s[|–-]\s/)[0] || '') + ')');
    // Required radio on the ECF form; must match one of its option values exactly.
    fd.append('artwork', 'Upload print-ready artwork now');
    fd.append('file', file);
    return fetch(PC_ECF_ENDPOINT, { method: 'POST', body: fd }).then(function (res) {
      if (!res.ok) throw new Error('Artwork upload failed (' + res.status + ')');
      return res;
    }, function () {
      throw new Error('Artwork upload failed (network)');
    });
  }

  var form = section.querySelector('[data-pc-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var addBtn = section.querySelector('[data-pc-add-to-cart]');
      var labelEl = section.querySelector('[data-pc-add-label]');
      var confirmEl = section.querySelector('[data-pc-add-confirm]');
      if (!addBtn) return;
      var variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      var file = currentFile();
      var email = artEmail ? artEmail.value.trim() : '';
      var formId = form.getAttribute('data-pc-artwork-form');

      if (file) {
        if (file.size > PC_MAX_FILE_BYTES) {
          showArtError('That file is over 20MB. Please choose a smaller file, or remove it and email your artwork through afterwards.');
          if (uz) uz.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (!validEmail(email)) {
          showArtError('Please enter your email address so we can match your artwork to your order.');
          if (artEmail) { artEmail.scrollIntoView({ behavior: 'smooth', block: 'center' }); artEmail.focus({ preventScroll: true }); }
          return;
        }
      }
      showArtError('');

      // Always return to the normal label afterwards (not 'Try again' left over from an earlier failed attempt)
      var originalLabel = addBtn.getAttribute('data-label-default') || 'Add to Cart';
      addBtn.disabled = true;
      if (confirmEl) confirmEl.hidden = true;

      var orderRef = makeOrderRef();
      var properties = { 'Order reference': orderRef };
      // Choice selectors and colour fields (anything named properties[...]) go on the cart line.
      section.querySelectorAll('[name^="properties["]').forEach(function (el) {
        if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
        if (el.closest('[hidden]')) return;
        var v = (el.value || '').trim();
        if (!v) return;
        properties[el.name.slice(11, -1)] = v;
      });
      var upload;
      if (file && formId) {
        if (labelEl) labelEl.textContent = 'Uploading artwork…';
        upload = uploadArtwork(file, email, formId, orderRef).then(function () {
          properties['Artwork file'] = file.name;
          properties['Artwork email'] = email;
        });
      } else {
        upload = Promise.resolve();
      }

      upload
        .then(function () {
          if (labelEl) labelEl.textContent = 'Adding…';
          var item = { id: variantId, quantity: 1, properties: properties };
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [item] })
          }).then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          });
        })
        .then(function () {
          if (labelEl) labelEl.textContent = 'Added ✓';
          if (confirmEl) {
            var refEl = confirmEl.querySelector('[data-pc-order-ref]');
            if (!refEl) {
              refEl = document.createElement('div');
              refEl.setAttribute('data-pc-order-ref', '');
              refEl.style.marginTop = '6px';
              confirmEl.appendChild(refEl);
            }
            refEl.textContent = 'Your order reference is ' + orderRef + '. Quote it if you email your artwork.';
            confirmEl.hidden = false;
          }
          if (file && fileInput) { fileInput.value = ''; syncFileUi(); }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () {
            addBtn.disabled = false;
            if (labelEl) labelEl.textContent = originalLabel;
          }, 2200);
        })
        .catch(function (err) {
          addBtn.disabled = false;
          if (labelEl) labelEl.textContent = 'Try again';
          if (file && err instanceof Error && /Artwork upload/.test(err.message)) {
            showArtError('Sorry, your artwork did not upload. Please try again, or remove the file, add the order and email your artwork through afterwards.');
          }
        });
    });
  }

  render();
}

// Enquiry-only product pages (no order box): start the 'What do you need?' box with the
// product name, so enquiries from different pages can be told apart.
function pcPrefillEnquiry(scope) {
  scope.querySelectorAll('.pc-section [id^="pc-enquiry-"] textarea[name="details"]').forEach(function (ta) {
    if (ta.value.trim()) return;
    var h = document.querySelector('.pc-head-title, h1');
    var name = (h && h.textContent.trim()) || (document.title.split(/\s[|–-]\s/)[0] || '').trim();
    if (name) ta.value = 'Product: ' + name + '\n\n';
  });
}

function pcInitAll(root) {
  var scope = root || document;
  if (scope.matches && scope.matches('.pc-section')) pcInit(scope);
  scope.querySelectorAll('.pc-section').forEach(pcInit);
  pcPrefillEnquiry(scope);
}

document.addEventListener('DOMContentLoaded', function () {
  pcReveal();
  pcInitAll();
});

document.addEventListener('shopify:section:load', function (event) {
  pcReveal(event.target);
  pcInitAll(event.target);
});
